import styled from 'styled-components';
import { primaryColor } from '../../config/colors';

export const Nav = styled.nav`
  background: #fff;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;


  a {
    color: #024089;
    margin: 0 10px 0 0;
    font-weight: bold;
  }

  div {
    margin: 0 10px 0 0;
  }

  img {
    max-width: 2rem;
  }
`;
